const projects = [
  {
    name: "WhoDat",
    url: "https://whodat.netlify.app/",
    demo: "https://youtu.be/upXlZz9HJiE",
    frontent: "",
    backend: "",
    technologies: "React • Redux • Rails • JWT • Custom CSS • Semantic UI React",
    api: "Clarifai API • TMDB API",
    description: "Shazam for faces! Capture celebrity photos mid-movie to see an actor’s name, filmography, a link to their IMDB and more. Now that's smart.",
    img: "whodat.png"
  },
  {
    name: "Words With Nerds",
    url: "https://wordswithnerds.herokuapp.com/",
    demo: "https://youtu.be/DpBaDUpblTM",
    frontent: "",
    backend: "",
    technologies: "Vanilla JS • Rails • Custom CSS • Semantic UI",
    api: "-",
    description: "A game for word enthusiasts. Form words by typing letters that you see on the board. Keep playing until the board fills up. Careful, it's addictive!",
    img: "wwn.png"
  },
  {
    name: "Destination Unknown",
    url: "https://destination-unknown.herokuapp.com/",
    demo: "https://youtu.be/WLdMXpGrEZQ",
    frontent: "",
    backend: "",
    technologies: "React • Rails • JWT • Custom CSS • Semantic UI React",
    api: "Kiwi API",
    description: "Find unique destinations within your budget. Search for flights using only a start location, date, and maximum ticket price. Go explore!",
    img: "du.png"
  },
  {
    name: "Find Your Foodie",
    url: "https://findyourfoodie.herokuapp.com/",
    demo: "",
    frontent: "",
    backend: "",
    technologies: "Ruby on Rails • Custom CSS • Semantic UI",
    api: "-",
    description: "Social media for foodies! Find and connect with other food fans. Match based on food preferences, chat and more. Getting hungry?",
    img: "fyf.png"
  },
]

export default projects
